export default {
  model () {
    return {
      name: null,
      dealerId: '',
      type: '',
      isMainBranch: false,
      state: '',
      municipality: '',
      suburb: '',
      street: '',
      zipCode: null,
      internalNumber: '',
      externalNumber: ''
    }
  },
  rules: {
    name: [
      { required: true, message: 'El nombre es requerido' },
      {
        min: 1,
        max: 255,
        message: 'El nombre debe ser entre 1 y 255 carácteres'
      }
    ],
    dealerId: { required: true, message: 'El distribuidor es requerido' },
    type: { required: true, message: 'El tipo de sucursal es requerido' },
    state: [
      { required: true, message: 'El estado es requerido' },
      {
        min: 2,
        max: 255,
        message: 'El estado debe ser entre 2 y 255 carácteres'
      }
    ],
    municipality: [
      { required: true, message: 'El municipio es requerido' },
      {
        min: 2,
        max: 255,
        message: 'El municipio debe ser entre 2 y 255 carácteres'
      }
    ],
    suburb: [
      { required: true, message: 'El tipo de sucursal es requerido' },
      {
        min: 2,
        max: 255,
        message: 'La colonia debe ser entre 2 y 255 carácteres'
      }
    ],
    street: {
      min: 2,
      max: 255,
      message: 'La calle debe ser entre 1 y 255 carácteres'
    },
    zipCode: [
      { required: true, message: 'El código postal es requerido' },
      {
        min: 1,
        max: 255,
        message: 'El código postal debe ser entre 4 y 5 números'
      }
    ],
    internalNumber: {
      max: 20,
      message: 'El número interior debe ser menor a 20 carácteres'
    },
    externalNumber: {
      max: 20,
      message: 'El número exterior debe ser menor a 20 carácteres'
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/branches/branches.model.js